import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatPaginator, PageEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';
import { ImportarProdutosModalComponent } from '../modals/importar-produtos-modal/importar-produtos-modal.component';
import { ImportarLotesModalComponent } from '../modals/importar-lotes-modal/importar-lotes-modal.component';
import { Filtro } from '../models/filtro';
import { Familia, Produto } from '../models/produto';
import { CarregandoService } from '../services/carregando.service';
import { GlobalService } from '../services/global.service';
import { NotificacaoService } from '../services/notificacao.service';
import { PremissasService } from '../services/premissas.service';
import { ProdutoService } from '../services/produto.service';
import { UtilitarioService } from '../services/utilitario.service';
import { EstoqueModalComponent } from '../modals/estoque-modal/estoque-modal.component';
import { HistoricoDoPrecoModalComponent } from '../modals/historico-do-preco-modal/historico-do-preco-modal.component';
import { Marca } from '../models/marca';
import { MarcaService } from '../services/marca.service';
import { FuncionarioService } from '../services/funcionario.service';
import { PaginatorService } from '../services/paginator.service';
import { PerfilDoUsuario } from '../models/enum';
import { Categoria } from '../models/categoria';
import { CategoriaService } from '../services/categoria.service';

declare const $: any;

@Component({
  selector: "app-produtos",
  templateUrl: "./produtos.component.html",
  styleUrls: ["./produtos.component.scss"],
})
export class ProdutosComponent implements OnInit, OnDestroy {
  // variáveis
  PerfilDoUsuario = PerfilDoUsuario;
  integracoes: any;
  produtosFiltrados: Produto[] = [];
  carregando = true;
  campoOrdenacao = "descricao";
  ordenarDesc = false;
  editavel = true;
  paginacao;
  listaDeItensPorPagina;
  itensPorPagina;
  filtroNome: Filtro = { Propriedade: "descricao", Valor: "" };
  filtroCodBarra: Filtro = { Propriedade: "codbarra", Valor: "" };
  filtroCodErp: Filtro = { Propriedade: "coderp", Valor: "" };
  filtroReferencia: Filtro = { Propriedade: "referencia", Valor: "" };
  filtroFamilia: Filtro = { Propriedade: "familia", Valor: "" };
  filtros: Filtro[] = [this.filtroNome, this.filtroCodBarra, this.filtroCodErp, this.filtroReferencia];
  status = [
    { id: "", nome: "Todos" },
    { id: "A", nome: "Ativo" },
    { id: "B", nome: "Bloqueado" },
  ];
  statusSelecionado = "A";
  potMin: number;
  potMax: number;
  filtrouPotencia = false;
  filtroProdutos: any;
  administrador = false;
  familias: Familia[] = [];
  familiaSelecionada: any;
  mostrarCodErp: false;
  integrador = false;
  verCustos = "N";
  multiFornecedores = false;
  usarCentroDeDistribuicao = false;
  podeVerEstoque = false;

  marcas: Marca[] = [];
  marcaSelecionado = undefined;

  bloquearSistema: boolean = false;
  perfil;

  categorias: Categoria[] = [];
  categoriaSelecionada = null;

  usaProdutoLote: boolean = false;

  @ViewChild("paginator", { static: false }) paginator: MatPaginator;

  constructor(
    private produtoService: ProdutoService,
    public utilitarioService: UtilitarioService,
    private router: Router,
    private globalService: GlobalService,
    private route: ActivatedRoute,
    private carregandoService: CarregandoService,
    private notificacaoService: NotificacaoService,
    public dialog: MatDialog,
    private premissasService: PremissasService,
    private marcaService: MarcaService,
    public funcionarioService: FuncionarioService,
    private paginatorService: PaginatorService,
    private categoriaService: CategoriaService
  ) { }

  async ngOnInit() {
    const userId = await (await this.globalService.consultaUsuario()).id;

    this.perfil = await this.globalService.perfil();
    this.administrador = await this.globalService.administrador();
    this.integrador = await this.globalService.integrador();
    this.verCustos = (await this.globalService.consultaUsuario()).verCustos;

    const pagination = this.paginatorService.consultarPaginacao();

    this.paginacao = pagination.paginacao;
    this.itensPorPagina = pagination.itensPorPagina;
    this.listaDeItensPorPagina = pagination.listaDeItensPorPagina;

    this.buscarMostrarCodErp();
    this.buscarFamilias();
    this.buscarCategorias();
    this.buscarMultiFornecedores();
    this.buscarPremissaCentroDeDistribuicao();
    this.consultaPodeVerEstoque(userId);
    this.buscarPremissasBloqueioSistema();
    this.buscarPremissasSistema();

    if (localStorage.getItem("filtroProdutos") !== null) {
      this.filtroProdutos = JSON.parse(localStorage.getItem("filtroProdutos"));
      this.filtroCodBarra.Valor = this.filtroProdutos.codBarra;
      this.filtroCodErp.Valor = this.filtroProdutos.codErp;
      this.filtroReferencia.Valor = this.filtroProdutos.referencia;
      this.filtroNome.Valor = this.filtroProdutos.nome;
      this.statusSelecionado = this.filtroProdutos.status;
      this.familiaSelecionada = this.filtroProdutos.familia;
      this.marcaSelecionado = this.filtroProdutos.marca;

      await this.buscarMarcas();

      this.buscarProdutos();
    } else {
      await this.buscarMarcas();

      this.buscarProdutos();
    }
  }

  buscarPremissasBloqueioSistema() {
    this.carregandoService.mostra("buscarBloqSist");
    this.premissasService.consultarBloqSistManuProd().subscribe(
      (data) => {
        this.bloquearSistema = data;
        this.carregandoService.esconde("buscarBloqSist");
      },
      (erro) => {
        this.carregandoService.esconde("buscarBloqSist");
        this.notificacaoService.erro(erro);
      }
    );
  }

  consultaPodeVerEstoque(id: number) {
    this.carregandoService.mostra("podeVerEstoque");
    this.funcionarioService.consultaPodeVerEstoque(id).subscribe(
      (resp) => {
        this.podeVerEstoque = resp;
        this.carregandoService.esconde("podeVerEstoque");
      },
      (erro) => {
        this.carregandoService.esconde("podeVerEstoque");
        console.error(erro);
        this.notificacaoService.erro("Não foi possível verificar se o usuário pode ver o estoque.");
      }
    );
  }

  buscarPremissaCentroDeDistribuicao() {
    this.carregandoService.mostra("buscarPremissaCentroDeDistribuicao");
    this.premissasService.consultarCentroDeDistribuicao().subscribe(
      (centro) => {
        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");

        if (centro.valor) {
          this.usarCentroDeDistribuicao = true;
        }
      },
      (err) => {
        this.carregandoService.esconde("buscarPremissaCentroDeDistribuicao");
        this.notificacaoService.erro(err);
      }
    );
  }

  async buscarMarcas() {
    try {
      this.carregandoService.mostra("buscaMarcas");

      if (this.familiaSelecionada === null || this.familiaSelecionada === undefined) {
        this.marcas = await this.marcaService.consultarMarcas().toPromise();
      } else {
        this.marcas = await this.marcaService.listarPorFamilia(this.familiaSelecionada, true).toPromise();
      }

      this.carregandoService.esconde("buscaMarcas");
    } catch (erro) {
      this.carregandoService.esconde("buscaMarcas");
      this.notificacaoService.erro(erro);
    }
  }

  buscarMultiFornecedores() {
    this.carregandoService.mostra("buscarMultiFornecedores");
    this.premissasService.consultarMultiFornecedores().subscribe(
      (f) => {
        this.multiFornecedores = f.valor;
        this.carregandoService.esconde("buscarMultiFornecedores");
      },
      (erro) => {
        this.carregandoService.esconde("buscarMultiFornecedores");
        this.notificacaoService.erro(erro);
      }
    );
  }

  ordena(campo) {
    if (campo) {
      this.campoOrdenacao = campo;
      this.ordenarDesc = !this.ordenarDesc;

      this.mudaDePagina({
        length: this.paginator.length,
        pageIndex: this.paginator.pageIndex,
        pageSize: this.paginator.pageSize,
      });
    }

    return false;
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    if (typeof a === "string") {
      a = a.toLowerCase();
    }

    if (typeof b === "string") {
      b = b.toLowerCase();
    }

    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  filtra() {
    this.buscarProdutos();
    this.paginator.firstPage();
    this.filtroProdutos = {
      codBarra: this.filtroCodBarra.Valor,
      codErp: this.filtroCodErp.Valor,
      referencia: this.filtroReferencia.Valor,
      nome: this.filtroNome.Valor,
      status: this.statusSelecionado,
      familia: this.familiaSelecionada,
      marca: this.marcaSelecionado,
      potMin: this.potMin,
      potMax: this.potMax,
    };
    localStorage.setItem("filtroProdutos", JSON.stringify(this.filtroProdutos));
  }

  buscarProdutos() {
    this.carregandoService.mostra("buscaProdutos");

    this.produtoService
      .consultarComPaginacao(
        this.paginacao.paginaAtual,
        this.itensPorPagina,
        this.campoOrdenacao,
        this.ordenarDesc ? "desc" : "asc",
        this.filtroNome.Valor,
        this.filtroCodBarra.Valor,
        this.statusSelecionado,
        this.familiaSelecionada,
        false,
        undefined,
        this.marcaSelecionado,
        null,
        this.potMin != null && this.potMin ? this.potMin.toString() : null,
        this.potMax != null && this.potMax != undefined ? this.potMax.toString() : null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        true,
        this.filtroCodErp.Valor,
        this.filtroReferencia.Valor,
        null,
        null,
        this.categoriaSelecionada
      )
      .subscribe(
        (dados) => {
          this.produtosFiltrados = dados.itens;

          if (this.itensPorPagina > this.listaDeItensPorPagina[this.listaDeItensPorPagina.length - 1]) {
            this.itensPorPagina = 10;
          }

          this.paginacao.total = dados.total;

          this.carregando = false;
          this.carregandoService.esconde("buscaProdutos");
        },
        (erro) => {
          this.carregandoService.esconde("buscaProdutos");
          this.notificacaoService.erro(erro);
        }
      );
  }

  novoProduto() {
    this.router.navigate(["novo"], { relativeTo: this.route });
  }

  editarProduto(produto: Produto) {
    this.router.navigate(["editar", produto.idProduto], { relativeTo: this.route });
  }

  ativarProduto(produto: Produto) {
    swal({
      title: "Atenção!!",
      text: "Deseja realmente ativar o Produto?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-info",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra("ativarProduto");
        this.produtoService.ativar(produto.idProduto).subscribe(
          (resp) => {
            this.notificacaoService.sucesso("Produto ativado com sucesso!!!");
            this.carregandoService.esconde("ativarProduto");
            this.filtra();
          },
          (erro) => {
            this.carregandoService.esconde("ativarProduto");
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  bloquearProduto(produto: Produto) {
    swal({
      title: "Atenção!!",
      text: "Deseja realmente bloquear o Produto?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-info",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra("bloquearProduto");
        this.produtoService.bloquear(produto.idProduto).subscribe(
          (resp) => {
            this.notificacaoService.sucesso("Produto bloqueado com sucesso!!!");
            this.carregandoService.esconde("bloquearProduto");
            this.filtra();
          },
          (erro) => {
            this.carregandoService.esconde("bloquearProduto");
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  inativarProduto(produto: Produto) {
    swal({
      title: "Atenção!!",
      text: "Deseja realmente inativar o Produto?",
      type: "warning",
      showCancelButton: true,
      confirmButtonClass: "btn btn-info",
      cancelButtonClass: "btn btn-danger",
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
      buttonsStyling: false,
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra("inativarProduto");
        this.produtoService.inativar(produto.idProduto).subscribe(
          (resp) => {
            this.notificacaoService.sucesso("Produto inativado com sucesso!!!");
            this.carregandoService.esconde("inativarProduto");
            this.filtra();
          },
          (erro) => {
            this.carregandoService.esconde("inativarProduto");
            this.notificacaoService.erro(erro);
          }
        );
      }
    });
  }

  mudaDePagina(pageEvent: PageEvent) {
    if (this.itensPorPagina !== pageEvent.pageSize) this.paginatorService.salvaPaginacao(pageEvent.pageSize);

    this.itensPorPagina = pageEvent.pageSize;
    this.paginacao.paginaAtual = pageEvent.pageIndex + 1;

    this.buscarProdutos();
  }

  ngOnDestroy(): void { }

  duplicarProduto(produto: Produto) {
    this.router.navigate(["novo"], { state: { idProduto: produto.idProduto }, relativeTo: this.route });
  }

  buscarFamilias() {
    this.carregandoService.mostra("buscarFamilias");

    this.produtoService.consultarFamilias().subscribe(
      (famis) => {
        this.familias = famis;

        this.carregandoService.esconde("buscarFamilias");
      },
      (erro) => {
        this.carregandoService.esconde("buscarFamilias");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarCategorias() {
    this.carregandoService.mostra("buscarCategoias");
    this.categoriaService.listar().subscribe(
      (data) => {
        this.categorias = data;
        this.carregandoService.esconde("buscarCategoias");
      },
      (erro) => {
        this.carregandoService.esconde("buscarCategoias");
        this.notificacaoService.erro(erro);
      }
    );
  }

  importarProdutos(kits, produtos, atualizarProdutos: boolean = false) {
    const largura = Number($("body").width());

    let tipoImportacao = 0;

    if (produtos) {
      tipoImportacao = 1;
    } else if (atualizarProdutos) {
      tipoImportacao = 2;
    } else if (!kits) {
      tipoImportacao = 3;
    }

    const dialogRef = this.dialog.open(ImportarProdutosModalComponent, {
      width: largura > 1050 ? "1000px" : $("body").width().toString() + "px",
      data: {
        kits: kits,
        importarProdutos: produtos,
        tipoImportacao: tipoImportacao
      },
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarProdutos();
      }
    });
  }

  baixarModelo() {
    this.carregandoService.mostra("baixarArquivo");
    this.produtoService.baixarModelo().subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, "Produto_painel_inversor.xlsx");
        this.carregandoService.esconde("baixarArquivo");
      },
      (erro) => {
        this.carregandoService.esconde("baixarArquivo");
        this.notificacaoService.erro(erro);
      }
    );
  }

  baixarModeloKit() {
    this.carregandoService.mostra("baixarArquivo");
    this.produtoService.baixarModeloKit().subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, "Produto_kit.xlsx");
        this.carregandoService.esconde("baixarArquivo");
      },
      (erro) => {
        this.carregandoService.esconde("baixarArquivo");
        this.notificacaoService.erro(erro);
      }
    );
  }

  baixarModeloProdutos() {
    this.carregandoService.mostra("baixarModeloProdutos");
    this.produtoService.baixarModeloProdutos().subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, "Modelo_Produtos.xlsx");
        this.carregandoService.esconde("baixarModeloProdutos");
      },
      (erro) => {
        this.carregandoService.esconde("baixarModeloProdutos");
        this.notificacaoService.erro(erro);
      }
    );
  }

  exportarProdutos() {
    this.carregandoService.mostra("exportarProdutos");
    this.produtoService.exportarProdutos().subscribe(
      (arq) => {
        this.utilitarioService.saveBlob(arq, "Produtos.xlsx");
        this.carregandoService.esconde("exportarProdutos");
      },
      (erro) => {
        this.carregandoService.esconde("exportarProdutos");
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarMostrarCodErp() {
    this.carregandoService.mostra("buscarMostrarCodErp");
    this.premissasService.consultarMostrarCodErp().subscribe(
      (f) => {
        this.mostrarCodErp = f.valor;
        this.carregandoService.esconde("buscarMostrarCodErp");
      },
      (erro) => {
        this.carregandoService.esconde("buscarMostrarCodErp");
        this.notificacaoService.erro(erro);
      }
    );
  }

  pesquisarEstoque() {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(EstoqueModalComponent, {
      width: $("body").width().toString() + "px",
      data: {},
      panelClass: "modal-card",
    });
  }

  mostrarHistorico(produto: Produto) {
    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(HistoricoDoPrecoModalComponent, {
      width: $("body").width().toString() + "px",
      data: { produto: produto, idFornecedor: null },
      panelClass: "modal-card",
    });
  }

  ehUsuarioSuporte() {
    return this.perfil === PerfilDoUsuario.Suporte;
  }

  validarPotencias() {
    if (this.potMin !== null && this.potMin !== undefined && this.potMax !== null && this.potMax !== undefined) {
      if (Number(this.potMin) > Number(this.potMax)) {
        this.notificacaoService.erro("A Potência De deve ser menor que a Potência Até.");
        this.potMax = this.potMin;
      } else {
        this.filtra();
      }
    }
  }

  buscarPremissasSistema() {
    this.carregandoService.mostra("buscarPremissasSistema");
    this.premissasService.consultarPremissasSistema().subscribe(
      (ps) => {
        this.usaProdutoLote = ps.usaProdutoLote;

        this.carregandoService.esconde("buscarPremissasSistema");
      },
      (erro) => {
        this.carregandoService.esconde("buscarPremissasSistema");
        this.notificacaoService.erro(erro);
      }
    );
  }

  importarLotes() {
    if (!this.usaProdutoLote) {
      return;
    }

    const largura = Number($("body").width());

    const dialogRef = this.dialog.open(ImportarLotesModalComponent, {
      width: largura > 1050 ? "1000px" : $("body").width().toString() + "px",
      data: {},
      panelClass: "modal-card",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.buscarProdutos();
      }
    });
  }
}
